import { useLanguage } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  const items = t("marquee");

  return (
    <div className="overflow-hidden border-y border-slate-200 bg-white py-6" data-testid="expertise-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-12">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className="font-display text-xl font-bold uppercase tracking-[0.15em] text-slate-300 sm:text-2xl">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-sky-600" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
